import React from 'react';
import { FullPageLoader } from '../Loading';

const SplashScreen: React.FC = () => <FullPageLoader />;

export default SplashScreen;
